/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, {useRef, useEffect, useState} from 'react';

import {Box, Typography, useMediaQuery, useTheme} from '@mui/material';
import {getRefTagAndOrigin, ImgNextGen} from './homeCategory';
import Slider from 'react-slick';

import {IconTag} from './constants';
import loadAds from '@jobseeker/common-core/lib/helpers/loadAds';
import {
  handleTracking,
  TrackEventUBA,
} from '@jobseeker/common-core/lib/utils/analytics';
import {useRouter} from 'next/router';

const createMarkup = (title: any) => {
  return {__html: title};
};

export const getNewDriveBannerData = async (
  slotId = AdsSlot.IMAGE_CAROUSEL
) => {
  const resp = await loadAds(slotId);
  return resp;
};

const s3Url = 'https://staticlogo.hirist.com';
const AdsSlot = {
  COMPANY_LOGOS_TALENT_BRIDGE_DRIVE: '673ecaa0f46ad596cce5657c',
  IMAGE_CAROUSEL: '6728767f975b01b34ee3494d',
};
// Define types for props and state
interface HomePageCompanyIconsProps {
  isTechDrive: boolean;
}

interface DriveCompanyLogo {
  'Image Url': string;
}

const HomePageCompanyIcons: React.FC<HomePageCompanyIconsProps> = ({
  isTechDrive,
}) => {
  const useUserAgent = () => {
    const [userAgent, setUserAgent] = useState<string>('');

    useEffect(() => {
      if (typeof navigator !== 'undefined') {
        setUserAgent(navigator.userAgent || navigator.vendor || '');
      }
    }, []);

    return userAgent;
  };
  const userAgent = useUserAgent();
  const [driveCompaniesLogos, setDriveCompaniesLogos] = useState<
    DriveCompanyLogo[]
  >([]);
  const router = useRouter();

  useEffect(() => {
    if (isTechDrive) {
      const fetchData = async () => {
        const obj = await getNewDriveBannerData(
          AdsSlot.COMPANY_LOGOS_TALENT_BRIDGE_DRIVE
        );
        if (Object.keys(obj).length === 0) {
          setDriveCompaniesLogos(obj);
        }
      };
      fetchData();
    }
  }, [isTechDrive]);

  const content = (isTechDrive ? driveCompaniesLogos : IconTag).map(
    (icon, indx) => {
      if (indx % 2 === 1) return null;
      return (
        <div key={indx} className="top-companies-icon-wrapper">
          <div className="top-tech-company-icon">
            <ImgNextGen
              width={'160px'}
              style={{marginBottom: '38px'}}
              srcWebp={
                isTechDrive
                  ? driveCompaniesLogos[indx]['Image Url']
                  : `${s3Url}/webp/${IconTag[indx].CompanyIconTag}.webp`
              }
              fallback={
                isTechDrive
                  ? driveCompaniesLogos[indx]['Image Url']
                  : `${s3Url}/${IconTag[indx].CompanyIconTag}.png`
              }
            />
          </div>
          {indx + 1 < (isTechDrive ? driveCompaniesLogos : IconTag).length && (
            <div className="top-tech-company-icon">
              <ImgNextGen
                width={'160px'}
                srcWebp={
                  isTechDrive
                    ? driveCompaniesLogos[indx + 1]['Image Url']
                    : `${s3Url}/webp/${IconTag[indx + 1].CompanyIconTag}.webp`
                }
                fallback={
                  isTechDrive
                    ? driveCompaniesLogos[indx + 1]['Image Url']
                    : `${s3Url}/${IconTag[indx + 1].CompanyIconTag}.png`
                }
              />
            </div>
          )}
        </div>
      );
    }
  );

  const Header = isTechDrive
    ? 'Top companies that are participating'
    : "More than <b style='font-weight:800'>50k recruiters</b> from leading tech companies are hiring";

  const nextSlide = () => {
    slider.current?.slickNext();
  };

  const prevSlide = () => {
    slider.current?.slickPrev();
  };

  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up(1096)); // 1096px and above
  const isMediumScreen = useMediaQuery(theme.breakpoints.between(867, 1095)); // Between 867px and 1095px
  const isSmallScreen = useMediaQuery(theme.breakpoints.between(696, 866)); // Between 696px and 866px
  const isExtraSmallScreen = useMediaQuery(theme.breakpoints.between(545, 695)); // Between 545px and 695px
  const isTinyScreen = useMediaQuery(theme.breakpoints.between(360, 544)); // Between 360px and 544px

  const noOfSlidesToShow = () => {
    if (isLargeScreen) return 5;
    if (isMediumScreen) return 5;
    if (isSmallScreen) return 4;
    if (isExtraSmallScreen) return 3;
    if (isTinyScreen) return 2;

    return 1;
  };
  const slider = useRef<Slider | null>();

  const settings = {
    dots: false,
    speed: 500,
    slidesToShow: noOfSlidesToShow(),
    slidesToScroll: 1,
    adaptiveHeight: isTechDrive ? false : true,
    arrows: false,
    autoplay: true,
    infinite: true,
    appendDots: (dots: any) => (
      <div>
        <div className="dots-wraper">
          <span className="dotaround" onClick={prevSlide}></span>
          <span className="dotcenter"></span>
          <span className="dotaround" onClick={nextSlide}></span>
        </div>
      </div>
    ),
  };
  console.log(content);

  useEffect(() => {
    const {origin, refText} = getRefTagAndOrigin();

    handleTracking('jsViewTopCompaniesPanel', {
      event_category: 'jsHomePage',
      Source: `${origin}`,
      Device: sessionStorage.getItem('device') || 'desktop',
      Ref: `${refText}`,
    });
  }, []);
  return (
    <Box
      className="top-company-icons-main-wrapper"
      sx={{
        padding: {xs: '0 20px', sm: '0 41px', md: '0 68px'},
        marginBottom: {xs: 0, sm: '60px'},
        '@media(max-width: 1023px)': {
          width: '100%',
        },
      }}
    >
      <Box
        className="top-companies-heading-txt"
        sx={{
          textAlign: 'center',
          mb: 2,
          fontSize: {xs: '24px', sm: '32px'},
          fontFamily: 'Nunito Sans',
          fontWeight: 'bold',
          color: '#000',
        }}
      >
        <Typography
          component={'h2'}
          sx={{
            textAlign: 'center',
            mb: 2,
            fontSize: {md: '32px', xxs: '32px'},
            fontFamily: 'Nunito Sans',
            fontWeight: 'bold',
            color: '#000',
            lineHeight: {xxs: 1.2, md: 1.5},
          }}
          dangerouslySetInnerHTML={createMarkup(Header)}
        />
      </Box>
      <Box sx={{ml: 2, mr: {xl: -7, lg: -3}}}>
        <Slider ref={c => (slider.current = c)} {...settings}>
          {content}
        </Slider>
      </Box>
    </Box>
  );
};

export default HomePageCompanyIcons;
